<template>
  <div class="quote__additional">
    <div class="quote__header">
      <div class="quote__header-top">
        <div class="quote__title">{{$t('qic_quote_additional_header')}}
        </div>
        <div class="quote__price"><i>{{$t('qic_qar')}}</i> {{ quoteAdditionalPrice }}</div>
      </div>
    </div>
    <div class="quote__list">
      <div class="quote__accordion">
        <div class="quote__pab"
          v-for="(additional, index) of additionals"
          :key="index">
          <BaseAccordion >
            <template v-slot:name>
             {{ additional[additionalNameKey] }}
            <div class="accordion-additional">
              <label class="form-switch" @click.stop>
                <input type="checkbox" :value="additional[additionalIdKey]" v-model="selectedAdditionals_">
                <i></i>
              </label>
            </div>
            </template>
            <template v-slot:content>
               {{ additional.description }}
            </template>
          </BaseAccordion>
          <div class="quote__dropdown">
            <button type="button" class="quote__dropdown-btn">
              <div class="quote__dropdown-content">
                <div class="quote__dropdown-label">{{$t('qic_quote_insurance_amount')}}</div>
                <div class="quote__dropdown-amount">{{$t('qic_qar')}} {{ additional[additionalValueKey] | splitNumber}}</div>
              </div>
              <i class="sep">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.20921 6.68306C3.48816 6.43898 3.94042 6.43898 4.21936 6.68306L8 9.99112L11.7806 6.68306C12.0596 6.43898 12.5118 6.43898 12.7908 6.68306C13.0697 6.92714 13.0697 7.32286 12.7908 7.56694L8.50508 11.3169C8.22613 11.561 7.77387 11.561 7.49492 11.3169L3.20921 7.56694C2.93026 7.32286 2.93026 6.92714 3.20921 6.68306Z" fill="#526C82" fill-opacity="0.8"/>
                </svg>
              </i>
            </button>
            <ul class="quote__dropdown-list">
              <li>QAR 200000 <span>+QAR 500</span></li>
              <li>QAR 200000 <span>+QAR 500</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseAccordion from '../BaseAccordion.vue'
export default {
  name: 'QuoteAdditionalBenefits',
  components: {
    BaseAccordion
  },
  props: {
    additionals: { type: Array },
    selectedAdditionals: { type: Array },
    quoteAdditionalPrice: { type: Number },
    additionalNameKey: { type: String, default: 'name' },
    additionalValueKey: { type: String, default: 'value' },
    additionalIdKey: { type: String, default: 'id' }
  },
  emits: [
    'changeSelectedAdditionls'
  ],
  computed: {
    selectedAdditionals_: {
      get () {
        return this.selectedAdditionals
      },
      set (newValue) {
        this.$emit('changeSelectedAdditionls',
          {
            newAdditionals: newValue
          })
      }
    }
  }
}
</script>
